import { useEffect, useRef } from "react"
import { useCommonStateChanger } from "@/root/state/common/context"

export function useUpdateStagingEnv(stagingEnv?: string) {
  const updatedServerPropsRef = useRef(false)
  const commonDispatch = useCommonStateChanger()

  useEffect(() => {
    if (!updatedServerPropsRef.current && stagingEnv) {
      commonDispatch({
        type: 'UPDATE_STAGING_ENV',
        payload: {
          stagingEnv,
        },
      })

      updatedServerPropsRef.current = true
    }
  }, [commonDispatch, stagingEnv])
}